import { j as jsxRuntimeExports } from "../../../jsx-runtime-9d42c573.js";
import { twMerge } from "tailwind-merge";
import "react";
const Placeholder = ({
  type,
  showLoadingPlaceholder = true,
  placeholder = null,
  showErrorPlaceholder = true,
  errorPlaceholder = null,
  loadingPlaceholderClassName = "",
  errorPlaceholderClassName = ""
}) => {
  const _renderDefault = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      "data-testid": `placeholder-${type}`,
      className: twMerge(
        "w-full h-full bg-[#e6e6e6] rounded object-cover m-0 text-base",
        type === "loading" ? loadingPlaceholderClassName : "",
        type === "error" ? errorPlaceholderClassName : ""
      )
    }
  );
  if (type === "loading") {
    if (!showLoadingPlaceholder)
      return null;
    return placeholder || _renderDefault();
  }
  if (type === "error") {
    if (!showErrorPlaceholder)
      return null;
    return errorPlaceholder || _renderDefault();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};
export {
  Placeholder as default
};
//# sourceMappingURL=placeholder.js.map
